import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IExpenseState } from './expense.state';

export class ExpenseSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly expenseState = (state: IRootState): IExpenseState => {
    return state.expense as IExpenseState;
  };

  static readonly model = createSelector(ExpenseSelectors.expenseState, (expense: IExpenseState) => {
    return expense.model;
  });

  static readonly data = createSelector(ExpenseSelectors.expenseState, (expense: IExpenseState) => {
    return expense.data;
  });
}
